import { Button } from "@progress/kendo-react-buttons";
import { Grid, GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import React,{ useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../Core/store.hooks";
import { getMdcDataSelector, removeSeries } from "./mdcSlice";

interface WidgetProps{
    id:string;
    header:string;
    legendSeries:any[];
    updateLegendSeries:any;
}

const AdvancedLegendGrid = (props:WidgetProps) => {
    const [legendSeries, updateLegendSeries] = useState([]);
    const dispatch = useAppDispatch()

    useEffect(()=>{
        
        updateLegendSeries(props.legendSeries)
    },[props.legendSeries])

    const CustomCell = (props: GridCellProps) => {
        const [color, setColor] = useState("black");

        useEffect(()=>{
            if(props.dataItem.color){
                setColor(props.dataItem.color)
            }
        },[])

        const toggleDisabled = () =>{
            
            if(props.dataItem.series.visible){
                props.dataItem.series.hide()
                setColor("#dadada")
            }else{
                props.dataItem.series.show()
                setColor(props.dataItem.color.hex)
            }
        }

        const hoverOn = () =>{
            if(props.dataItem.series.visible){
                legendSeries.forEach((obj)=>{
                    if(props.dataItem.seriesID !== obj.series.dataFields.valueY){
                        
                        obj.series.strokeOpacity = 0.1;
                        obj.bullet.fillOpacity = 0;
                        obj.bullet.strokeOpacity = 0;
                    }
                })
            }
        }

        const hoverOff = () =>{
            legendSeries.forEach((obj)=>{
                obj.series.strokeOpacity = 1
                obj.bullet.fillOpacity = 1
                obj.bullet.strokeOpacity = 1
            })
        }

        return(
            <td onClick={toggleDisabled} onMouseOver={hoverOn} onMouseLeave={hoverOff} style={{ "color": color, "cursor": "pointer", "userSelect": "none" }}>
                {props.dataItem.device + " " + props.dataItem.header + " (" + props.dataItem.unit+")"}
          </td>
        )
      }

    const handleGridButton = (seriesID:string) =>{
        dispatch(removeSeries(seriesID));
    }

    const CommandCell = (props:GridCellProps) => {
        return(
          <td> 
            <Button title="Remove Series" className="pp-small-kendo-button" onClick={()=>handleGridButton(props.dataItem.seriesID)}>REMOVE</Button>
          </td>
        )
      }

    return (<div className="pp-slim-grid">
        <Grid data={legendSeries} style={{ fontSize: "13px", height: " 100%" }} resizable={true}>
            <GridColumn title="Series Name" cell={CustomCell} width="180px" />
            {/* <GridColumn field="header" title="Header" width="160px" />*/}

            <GridColumn title="Remove Series" cell={CommandCell} width="70px" />

            <GridColumn field="unit" title="Unit" width="50px" />
        <GridColumn field="min" title="Range Min" width="50px"/>
            <GridColumn field="max" title="Range Max" width="50px" />
            <GridColumn field="average" title="Range Average" width="60px" />
            <GridColumn field="sum" title="Range Sum" width="50px" />
            <GridColumn field="totalSum" title="All time Sum" width="50px" />

            <GridColumn field="initialValue" title="Initial Value" width="50px" />

    </Grid></div>
    )
}

export default AdvancedLegendGrid;